/* global axios */
import ApiClient from '../ApiClient';

class TiktokShopAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getCoupons(conversationID) {
    return axios.get(`${this.url}/${conversationID}/tiktok_shop/coupons`);
  }

  getOrders(params) {
    return axios.get(
      `${this.url}/${params.conversationID}/tiktok_shop/orders`,
      {
        params: {
          order_status: params.orderStatus,
        },
      }
    );
  }

  searchProducts(conversationID, searchQuery) {
    return axios.get(`${this.url}/${conversationID}/tiktok_shop/products`, {
      params: {
        q: searchQuery,
      },
    });
  }

  sendProduct(conversationID, productID) {
    return axios.post(
      `${this.url}/${conversationID}/tiktok_shop/send_product`,
      {
        item_id: productID,
      }
    );
  }

  sendOrder(conversationID, orderID) {
    return axios.post(`${this.url}/${conversationID}/tiktok_shop/send_order`, {
      order_id: orderID,
    });
  }
}

export default new TiktokShopAPI();
